import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface TenantContextType {
  selectedTenant: string;
  handleSetSelectedTenant: (id: string) => void;
}

const TenantContext = createContext<TenantContextType>({
  selectedTenant: '',
  handleSetSelectedTenant: (id: string) => {}
});

export function useTenant() {
  return useContext(TenantContext);
}

interface TenantProviderProps {
  children: ReactNode;
}

export function TenantProvider({ children }: TenantProviderProps) {
  const [selectedTenant, setSelectedTenant] = useState<string>(() => {
    return localStorage.getItem('selectedTenant') || '';
  });

  const handleSetSelectedTenant = (id: string) => {
    console.log('handleSetSelectedTenant', id);
    setSelectedTenant(id);
    localStorage.setItem('selectedTenant', id);
  };

  return (
    <TenantContext.Provider value={{ selectedTenant, handleSetSelectedTenant }}>
      {children}
    </TenantContext.Provider>
  );
} 